import styled from 'styled-components';
import { shouldForwardProp } from '@belong/themes';

export const ButtonUnstyled = styled.button.withConfig({
  shouldForwardProp: shouldForwardProp('width')
})`
  display: inline-block;
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: inherit;
  line-height: normal;
  -webkit-appearance: none;
  text-decoration: none;
`;
